import { BRAND_LIST, CountryLanguageSwitcher } from 'typings'
import * as Typings from '../typings'

const SwedenLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'se',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Sweden',
  SHORT_NAME: 'SE',

  DISPLAY_NAME: 'Sweden (English)',
  DISPLAY_COUNTRY: 'Sweden',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 62.0329767,
    INITIAL_LONGITUDE: 17.3787426,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Blekinge',
    '2': 'Dalarna',
    '3': 'Gävleborg',
    '4': 'Halland',
    '5': 'Jämtland',
    '6': 'Jönköping',
    '7': 'Kalmar',
    '8': 'Kronoberg',
    '9': 'Norrbotten',
    '10': 'Skåne',
    '11': 'Stockholm',
    '12': 'Södermanland',
    '13': 'Uppsala',
    '14': 'Värmland',
    '15': 'Västerbotten',
    '16': 'Västernorrland',
    '17': 'Västmanland',
    '18': 'Västra Götaland',
    '19': 'Örebro',
    '20': 'Östergötland',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/se/en/',

  MAP_URL: 'https://www.uniqlo.com/se/se/content/Stores_Landing_Page.html',
  MAP_MOBILE_URL: 'https://map.uniqlo.com/se/en/',

  CONTACT_US_URL: 'https://faq-se.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-se.uniqlo.com/pkb_Home_UQ_SE?l=en&c=category_uq_eu_dk_se%3ARenew_UQSE_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-se.uniqlo.com/pkb_Home_UQ_SE?l=en&c=category_uq_eu_dk_se%3ARenew_UQSE_C7_2',

  POSTCODE_FORMAT: /^[0-9]{3} [0-9]{2}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default SwedenLocale
